


import React, { useState } from 'react';
// FIX: Corrected Firebase User type usage.
import firebase from 'firebase/compat/app';
import { auth } from '../services/firebase';
import { LogoIcon } from './icons';

interface VerificationViewProps {
    user: firebase.User;
}

const VerificationView: React.FC<VerificationViewProps> = ({ user }) => {
    const [message, setMessage] = useState<string | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);

    const handleResendVerification = async () => {
        setLoading(true);
        setMessage(null);
        setError(null);
        try {
            await user.sendEmailVerification();
            setMessage('Se ha enviado un nuevo correo de verificación a tu dirección.');
        } catch (err: any) {
            console.error("Error resending verification email:", err);
            setError('No se pudo enviar el correo. Por favor, inténtalo de nuevo en unos minutos.');
        } finally {
            setLoading(false);
        }
    };

    const handleLogout = async () => {
        if(auth) {
            await auth.signOut();
        }
    };

    const handleReload = () => {
        window.location.reload();
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-light-background dark:bg-background p-4">
            <div className="w-full max-w-md bg-light-surface dark:bg-surface rounded-xl shadow-2xl border border-light-border dark:border-border p-8 text-center">
                <LogoIcon className="w-16 h-16 text-primary mx-auto mb-6" />
                <h1 className="text-2xl font-bold text-light-text-primary dark:text-text-primary">Verifica tu correo electrónico</h1>
                <p className="mt-4 text-light-text-secondary dark:text-text-secondary">
                    Te hemos enviado un enlace de verificación a <strong>{user.email}</strong>. Por favor, haz clic en el enlace para activar tu cuenta.
                    <br/><br/>
                    <strong className="text-amber-500 dark:text-amber-400">Importante:</strong> Si el correo está en tu carpeta de <strong>spam</strong>, primero debes marcarlo como <strong>"No es spam"</strong> para que el enlace de verificación se active.
                </p>

                {message && <p className="text-sm text-green-400 text-center mt-4 bg-green-500/10 p-3 rounded-lg">{message}</p>}
                {error && <p className="text-sm text-red-400 text-center mt-4 bg-red-500/10 p-3 rounded-lg">{error}</p>}
                
                <div className="mt-8 space-y-4">
                    <button 
                        onClick={handleReload} 
                        className="w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-secondary hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary transition-colors"
                    >
                        Ya lo he verificado, continuar
                    </button>
                    <button 
                        onClick={handleResendVerification} 
                        disabled={loading}
                        className="w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-primary hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:bg-gray-600 transition-colors"
                    >
                        {loading ? 'Enviando...' : 'Reenviar correo de verificación'}
                    </button>
                     <button 
                        onClick={handleLogout} 
                        className="w-full text-sm font-medium text-light-text-secondary dark:text-text-secondary hover:underline"
                    >
                        Cerrar sesión
                    </button>
                </div>
            </div>
        </div>
    );
};

export default VerificationView;